// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/css/async/" + chunkId + "." + {"2895": "a93dd776","7429": "16fcd5f9",}[chunkId] + ".css"
}